import React from 'react';
import { compose } from 'redux';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import _get from 'lodash/get';
import PropTypes from 'prop-types';
// Core components
import { ContainedButton } from 'components/core/Button';
import TextField from 'components/core/TextField';
// Custom
import { authShape } from 'constants/PropTypesShapes';
import { buildFormErrors, forgotPasswordConstraints } from 'utils/Forms';
import withFormManagement from 'hocs/WithFormManagement';
import withStateReinit from 'hocs/WithStateReinit';
import withTitle from 'hocs/WithTitle';
import Callout from 'components/misc/Callout';

class ForgotPasswordForm extends React.Component {
  constructor() {
    super();

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  // Handlers
  handleSubmit(e) {
    e.preventDefault();
    const {
      fields: { email },
      onErrorsChange,
      onSubmit,
    } = this.props;

    const errors = buildFormErrors({ email }, forgotPasswordConstraints);
    // Apply errors
    onErrorsChange(errors);

    // No error => validate form
    if (!errors) {
      onSubmit({ email });
    }
  }

  render() {
    const {
      fields: { email },
      errors,
      auth,
      onFieldsChange,
    } = this.props;

    const success = !!_get(auth, 'recoverPassword.post');

    return (
      <React.Fragment>
        {/* -----  SHOW MESSAGE ----- */}
        {success && (
          <div className="mb-3">
            <Callout severity="success" withInfoIcon>
              <LocalizedMessage id="success.recoverPassword" values={{ email }} />
            </Callout>
          </div>
        )}
        {/* ----- FORM ----- */}
        <form onSubmit={this.handleSubmit}>
          <TextField
            type="email"
            name="email"
            label={<LocalizedMessage id="field.email" />}
            value={email}
            required
            errorText={_get(errors, 'email')}
            onChange={(value) => onFieldsChange({ email: value })}
          />
          <div className="additional-info text-center text-small">
            <LocalizedMessage id="info.forgotPasswordProcedure" />
          </div>
          <div className="text-center" style={{ paddingTop: 36 }}>
            <ContainedButton type="submit" label={<LocalizedMessage id="button.send" />} />
          </div>
        </form>
      </React.Fragment>
    );
  }
}

ForgotPasswordForm.propTypes = {
  auth: authShape.isRequired,
  fields: PropTypes.object.isRequired,
  errors: PropTypes.object,
  onFieldsChange: PropTypes.func.isRequired,
  onErrorsChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

ForgotPasswordForm.defaultProps = {
  errors: null,
};

const mapFieldsToProps = {
  email: {
    defaultValue: '',
  },
};

const mapOwnPropsToResources = (ownProps) => ({
  operationError: ownProps.auth.error,
});

module.exports = compose(
  withFormManagement(mapFieldsToProps, mapOwnPropsToResources, false),
  withStateReinit(['auth']),
  withTitle('pageTitle.passwordForgotten'),
)(ForgotPasswordForm);



// WEBPACK FOOTER //
// ./routes/login/components/opac/ForgotPasswordForm.js